import React, { memo } from 'react';
import { DataListControl } from 'reactApp/ui/DataListControl/DataListControl';

import styles from '../DataListItemRow.css';
import { EViewMode } from 'reactApp/modules/settings/settings.types';

export const Publish = memo(({ onClick, isActive }: { isActive: boolean; onClick: (e: React.MouseEvent) => void }) => {
    return (
        <div className={styles.publish}>
            <DataListControl
                type="publish"
                active={isActive}
                onClick={onClick}
                hint="Поделиться ссылкой"
                viewType={EViewMode.list}
            />
        </div>
    );
});
Publish.displayName = 'Publish';
